import { render, staticRenderFns } from "./addCurrency.vue?vue&type=template&id=3d4c9104&scoped=true&"
import script from "./addCurrency.vue?vue&type=script&lang=js&"
export * from "./addCurrency.vue?vue&type=script&lang=js&"
import style0 from "./addCurrency.vue?vue&type=style&index=0&id=3d4c9104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4c9104",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d4c9104')) {
      api.createRecord('3d4c9104', component.options)
    } else {
      api.reload('3d4c9104', component.options)
    }
    module.hot.accept("./addCurrency.vue?vue&type=template&id=3d4c9104&scoped=true&", function () {
      api.rerender('3d4c9104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/communityDynamic/communityDynamicHome/components/addCurrency.vue"
export default component.exports